module.exports = __webpack_public_path__ + "img/prc.d97cad14.jpg";